<script>
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { mapGetters } from 'vuex'
import {
  warehouseMethods,
  reportsMethods,
  productsMethods,
} from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import ProductsTable from '@components/retina/products/productsTable'
import MultiSelectWarehouse from '@components/retina/MultiSelectWarehouse'

export default {
  name: 'Reports',
  page: {
    title: 'Reportes',
    meta: [
      {
        name: 'Reportes',
        content: 'Reportes',
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    BaseDatatable,
    MultiSelectWarehouse,
    ProductsTable,
  },
  data() {
    return {
      title: '<i class="fas fa-clipboard-check"></i> Reportes por Ubicación',
      items: [
        {
          text: 'Reportes',
        },
        {
          text: 'Lista de Reportes',
          active: true,
        },
      ],
      tableHeaders: [
        { key: 'info', label: 'Info' },
        { key: 'description', label: 'Descripción' },
        { key: 'actions', label: '', class: 'w-50' },
      ],
      tableHeadersUbications: [
        { key: 'nit', label: 'NIT', class: 'd-none d-lg-table-cell' },
        { key: 'name', label: 'Nombre' },
        { key: 'actions', label: '', class: 'w-50' },
      ],
      tableHeadersNovelty: [
        { key: 'name', label: 'Nombre' },
        { key: 'reference', label: 'Referencia' },
        { key: 'id_ext1', label: 'Extensión' },
        { key: 'novelty', label: 'Novedad' },
      ],
      tableHeadersBenchmark: [
        { key: 'name', label: 'Nombre' },
        { key: 'reference', label: 'Referencia' },
        { key: 'id_ext1', label: 'Extensión' },
        { key: 'quantity', label: 'Existencias' },
        { key: 'benchmark', label: 'Máximos' },
      ],
      tableHeadersSixMonthsAgo: [
        { key: 'name', label: 'Nombre' },
        { key: 'reference', label: 'Referencia' },
        { key: 'ext', label: 'Extensión' },
        { key: 'lote', label: 'Lote' },
        { key: 'serial', label: 'Serial' },
        { key: 'entry_date', label: 'Fecha de entrada' },
        { key: 'ubication_name', label: 'Ubicación'}
      ],
      modalConfigShow: false,
      filter: [],
      modalBenchmark: false,
      contentWarehouseModal: { description: '' },
      contentUbicationModal: { name: '', id: '' },
      benchmarkReport: { results: [] },
      loadingbenchmark: false,
      modalNovelty: false,
      loadingNovelty: false,
      modalSixMonthsAgo: false,
    }
  },
  computed: {
    ...mapGetters({
      warehouse_selected: 'retina/warehouse/warehouse_selected',
      ubication_selected: 'retina/warehouse/ubication_selected',
    }),
  },
  methods: {
    ...warehouseMethods,
    ...reportsMethods,
    ...productsMethods,
    myProvider(ctx) {
      let context = this
      const promise = context.fetchWarehouses(
        this.$table_params(ctx) + '&paginate=true'
      )
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          // console.log(error)
          return []
        })
    },
    benchmarkProvider(ctx) {
      let context = this
      const promise = context.fetchBenchmarkReport(
        this.$table_params(ctx) +
          '&warehouse=' +
          this.contentWarehouseModal.id +
          '&ubication=' +
          this.contentUbicationModal.id
      )
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },
    productsProvider(ctx) {
      let context = this
      const promise = context.fetchProducts(
        this.$table_params(ctx) +
          '&six_months_ago=true' +
          '&warehouse=' +
          this.contentWarehouseModal.id +
          '&ubication=' +
          this.contentUbicationModal.id
      )
      return promise
        .then(response => {return response.data})
        .then((data) => {
          return data
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          return []
        })
    },
    openModalBenchmark(warehouse, ubication) {
      let context = this
      this.modalBenchmark = true
      this.contentWarehouseModal = warehouse
      if (Boolean(ubication)) this.contentUbicationModal = ubication
      // this.loadingbenchmark = true
      // this.fetchBenchmarkReport(
      //   '?warehouse=' + warehouse.id + '&ubication=' + ubication.id
      // )
      //   .then((data) => {
      //     this.benchmarkReport = data
      //     this.loadingbenchmark = false
      //   })
      //   .catch((error) => {
      //     context.$axios_error_noty(error, context)
      //     this.loadingbenchmark = false
      //   })
    },
    hideModal() {
      this.contentWarehouseModal = { description: '' }
      this.contentUbicationModal = { name: '', id: '' }
      this.benchmarkReport = { results: [] }
    },
    openModalNovelty(warehouse, ubication) {
      let context = this
      this.modalNovelty = true
      this.contentWarehouseModal = warehouse
      if (Boolean(ubication)) this.contentUbicationModal = ubication
      this.loadingNovelty = true
      this.fetchBenchmarkReportnoset(
        '?warehouse=' +
          this.contentWarehouseModal.id +
          '&ubication=' +
          this.contentUbicationModal.id
      )
        .then((data) => {
          this.benchmarkReport = data
          this.loadingNovelty = false
        })
        .catch((error) => {
          context.$axios_error_noty(error, context)
          this.benchmarkReport = []
          this.loadingNovelty = false
        })
      // this.fetchBenchmarkReport(
      //   '?warehouse=' + warehouse.id + '&ubication=' + ubication.id
      // )
      //   .then((data) => {
      //     this.benchmarkReport = data
      //     this.loadingNovelty = false
      //   })
      //   .catch((error) => {
      //     context.$axios_error_noty(error, context)
      //     this.loadingNovelty = false
      //   })
    },
    openModalSixMonthsAgo(warehouse, ubication) {
      this.modalSixMonthsAgo = true
      this.contentWarehouseModal = warehouse
      if (Boolean(ubication)) this.contentUbicationModal = ubication
    },
    howLong(d) {
      let diff = this.$datetimesDiff(d, Date.now())
      let daydiff = diff / (1000 * 60 * 60 * 24)
      if (daydiff/30 < 1) return 'Entro hace ' + daydiff.toFixed(0) + ' dias'
      daydiff = daydiff/30
      return 'Entro hace ' + daydiff.toFixed(0) + ' meses'
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <b-card>
      <BaseDatatable
        ref="table"
        id="table1"
        :drfprovider="myProvider"
        :tableheaders="tableHeaders"
      >
        <template v-slot:cell(info)="row">
          <span class="text-blue">{{ row.item.code }}</span>
        </template>
        <template v-slot:cell(description)="row">
          {{ row.item.description }}
        </template>
        <template #cell(actions)="row">
          <b-button
            v-if="row.item.ubications.length > 0"
            size="sm"
            variant="link"
            class="text-info"
            @click="row.toggleDetails"
          >
            <span v-if="row.detailsShowing"
              ><i class="fas fa-search-minus fa-lg"></i>
              <span class="d-none d-md-inline"> Ver menos</span></span
            >
            <span v-else
              ><i class="fas fa-search-plus fa-lg"></i>
              <span class="d-none d-md-inline">
                Ver {{ row.item.ubications.length }} más</span
              >
              <span class="d-sm-inline d-md-none">
                {{ row.item.ubications.length }}</span
              >
            </span>
          </b-button>
          <b-dropdown
            v-else
            variant="link"
            toggle-class="text-decoration-none text-info"
            no-caret
            right
          >
            <template #button-content>
              <i class="fas fa-cog fa-lg text-info"></i>
              <span class="d-none d-md-inline"> Opciones</span>
            </template>
            <b-dropdown-item-button @click="openModalBenchmark(row.item, null)">
              <i class="fas fa-chart-line mr-1"></i> Máximos
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="openModalNovelty(row.item, null)">
              <i class="far fa-chart-bar mr-1"></i> Novedades
            </b-dropdown-item-button>
            <b-dropdown-item-button
              @click="openModalSixMonthsAgo(row.item, null)"
            >
              <i class="fas fa-clock mr-1"></i> Rotación de Inventario
            </b-dropdown-item-button>
          </b-dropdown>
        </template>

        <template #row-details="row">
          <b-row>
            <b-col md="5" class="mt-0 mb-1">
              <b-button variant="primary" @click="openModalSixMonthsAgo(row.item, null)">
                Reporte Total
              </b-button>
            </b-col>
            <b-col md="7" xs="12" class="mt-0 mb-1">
              <b-form-group
                label="Buscar"
                label-for="filter-input"
                label-cols-md="3"
                label-align-md="right"
                label-size="md"
                label-class="d-none d-md-block"
                :content-cols-md="9"
                :content-cols-xl="9"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter[row.item.id]"
                    type="search"
                    placeholder="Ingrese búsqueda"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter[row.item.id]"
                      @click="filter[row.item.id] = ''"
                    >
                      Limpiar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-table
            class="bg-white mb-0"
            :items="row.item.ubications"
            :filter="filter[row.item.id]"
            :fields="tableHeadersUbications"
            no-provider-filtering
          >
            <template #cell(nit)="row">
              <p class="pt-1 m-0">{{ row.item.nit }}</p>
            </template>
            <template #cell(name)="row">
              <small class="d-sm-inline d-md-none"
                >{{ row.item.nit }}<br
              /></small>
              {{ row.item.name }}
            </template>
            <template #cell(actions)="data">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none text-info"
                no-caret
                right
              >
                <template #button-content>
                  <i class="fas fa-cog fa-lg text-info"></i>
                  <span class="d-none d-md-inline"> Opciones</span>
                </template>
                <b-dropdown-item-button
                  @click="openModalBenchmark(row.item, data.item)"
                  ><i class="fas fa-chart-line mr-1"></i> Máximos
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  @click="openModalNovelty(row.item, data.item)"
                >
                  <i class="far fa-chart-bar mr-1"></i> Novedades
                </b-dropdown-item-button>
                <b-dropdown-item-button
                  @click="openModalSixMonthsAgo(row.item, data.item)"
                >
                  <i class="fas fa-clock mr-1"></i> Rotación de Inventario
                </b-dropdown-item-button>
              </b-dropdown>
            </template>
          </b-table>
        </template>
      </BaseDatatable>
      <b-modal
        v-model="modalBenchmark"
        size="xl"
        @hide="hideModal()"
        title="Máximos"
        ok-title="Aceptar"
        ok-only
      >
        <b-spinner v-if="loadingbenchmark" label="Spinning"></b-spinner>
        <div v-else>
          <p>{{ contentWarehouseModal.description }}</p>
          <p>{{ contentUbicationModal.name }}</p>
          <BaseDatatable
            ref="tableBenchmark"
            id="tablebenchmarkReport"
            :drfprovider="benchmarkProvider"
            :tableheaders="tableHeadersBenchmark"
          >
          </BaseDatatable>
        </div>
      </b-modal>
      <b-modal
        v-model="modalNovelty"
        size="xl"
        @hide="hideModal()"
        title="Novedades"
      >
        <b-spinner v-if="loadingNovelty" label="Spinning"></b-spinner>
        <div v-else>
          <p class="lead">{{ contentWarehouseModal.description }}</p>
          <p class="lead">{{ contentUbicationModal.name }}</p>
          <BaseDatatable
            ref="tableNovelty"
            id="tableNoveltyReport"
            :drfprovider="benchmarkProvider"
            :tableheaders="tableHeadersNovelty"
          >
            <template #cell(novelty)="row">
              <b-badge
                v-if="row.item.benchmark - row.item.quantity > 0"
                variant="secondary"
                >{{ row.item.quantity - row.item.benchmark }}</b-badge
              >
              <b-badge v-else variant="primary"
                >+{{ row.item.quantity - row.item.benchmark }}</b-badge
              >
              Productos
            </template>
          </BaseDatatable>
          <!-- {{benchmarkReport}} -->
          <br />
          <p class="lead">Productos no cargados</p>
          <b-table
            :items="benchmarkReport.results"
            :fields="tableHeadersNovelty"
            stacked="md"
            small
          >
            <!-- <template #cell(novelty)="row"> -->
            <template #cell(novelty)>
              <b-badge variant="secondary">
                No registra carga
              </b-badge>
            </template>
          </b-table>
        </div>
      </b-modal>
      <b-modal
        v-model="modalSixMonthsAgo"
        size="xl"
        @hide="hideModal()"
        title="Rotación de Inventario"
      >
        <p class="m-0">
          {{ contentWarehouseModal.description }}
        </p>
        <p class="m-0 mb-3">
          {{ contentUbicationModal.name }}
        </p>
        <BaseDatatable
          ref="tableSixMonthsAgo"
          id="tableSixMonthsAgo"
          :drfprovider="productsProvider"
          :tableheaders="tableHeadersSixMonthsAgo"
        >
          <template v-slot:cell(ext)="row">
            <span>{{ row.item.ext_detail }}</span>
          </template>
          <template v-slot:cell(entry_date)="row">
            <span>{{ row.item.entry_date }}</span>
            <p><strong>{{howLong(row.item.entry_date)}}</strong></p>
          </template>
        </BaseDatatable>
      </b-modal>
    </b-card>
  </Layout>
</template>
<style lang="scss">
#table1 {
  .text-center {
    text-align: center;
  }
  @media screen and (max-width: 765px) {
    .w-20 {
      width: 20px !important;
    }
    .w-50 {
      width: 50px !important;
    }
    .w-170 {
      width: 170px !important;
    }
  }
  @media screen and (min-width: 766px) {
    .w-20 {
      width: 120px !important;
    }
    .w-50 {
      width: 150px !important;
    }
    .w-170 {
      width: 230px !important;
    }
  }
  .b-table-details {
    background-color: #e2e6e9;
    padding-left: 5px;
    padding-top: 5px;
    thead {
      display: none;
    }
    table td {
      padding-top: 0;
      padding-bottom: 0;
    }
  }
}
</style>
